import React from "react";

function CallToAction(props) {
  return (
    <section id="cta" class="cta">
      <div class="container" data-aos="zoom-in">
        <div class="text-center">
          <h3>Call To Action</h3>
          <p>
            Black Box Software Solutions’ well-experienced Engineers are here to
            deliver an excellent Software Solutions. Our services are available
            in Afghanistan, and anywhere else around the Globe.
          </p>
          <a class="cta-btn" href="./ComingSoon/index.html">
            Call To Action
          </a>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
